export const dates = [
  {
    startDate: '2020-01-01T00:00:00.000Z',
    endDate: '2020-12-31T23:59:59.999Z',
  },
  {
    startDate: '2020-01-01T00:00:00.000Z',
    endDate: '2020-03-31T23:59:59.999Z',
  },
  {
    startDate: '2020-04-01T00:00:00.000Z',
    endDate: '2020-06-30T23:59:59.999Z',
  },
  {
    startDate: '2020-07-01T00:00:00.000Z',
    endDate: '2020-09-30T23:59:59.999Z',
  },
  {
    startDate: '2020-10-01T00:00:00.000Z',
    endDate: '2020-12-31T23:59:59.999Z',
  },
  {
    startDate: '2020-01-01T00:00:00.000Z',
    endDate: '2020-06-30T23:59:59.999Z',
  },
  {
    startDate: '2020-07-01T00:00:00.000Z',
    endDate: '2020-12-31T23:59:59.999Z',
  },
];

export const quarter_week: any = {
  0: [
    '2023_W27',
    '2023_W28',
    '2023_W29',
    '2023_W30',
    '2023_W31',
    '2023_W32',
    '2023_W33',
    '2023_W34',
    '2023_W35',
    '2023_W36',
    '2023_W37',
    '2023_W38',
    '2023_W39',
  ],
  1: [
    '2023_W27',
    '2023_W28',
    '2023_W29',
    '2023_W30',
    '2023_W31',
    '2023_W32',
    '2023_W33',
    '2023_W34',
    '2023_W35',
    '2023_W36',
    '2023_W37',
    '2023_W38',
    '2023_W39',
  ],
  2: [
    '2023_W40',
    '2023_W41',
    '2023_W42',
    '2023_W43',
    '2023_W44',
    '2023_W45',
    '2023_W46',
    '2023_W47',
    '2023_W48',
    '2023_W49',
    '2024_W50',
    '2024_W51',
    '2024_W52',
  ],
  3: [
    '2024_W1',
    '2024_W2',
    '2024_W3',
    '2024_W4',
    '2024_W5',
    '2024_W6',
    '2024_W7',
    '2024_W8',
    '2024_W9',
    '2024_W10',
    '2024_W11',
    '2024_W12',
    '2024_W13',
  ],
  4: [
    '2024_W14',
    '2024_W15',
    '2024_W16',
    '2024_W17',
    '2024_W18',
    '2024_W19',
    '2024_W20',
    '2024_W21',
    '2024_W22',
    '2024_W23',
    '2024_W24',
    '2024_W25',
    '2024_W26',
  ],
};

export const maxValList = [
  {
    //at
    fullYearMax: 23.74,
    fullYearMin: 0.0,
    quarterMax: 100,
    quarterMin: 0.92,
  },
  {
    //ca
    fullYearMax: 2.0,
    fullYearMin: 0.0,
    quarterMax: 4.0,
    quarterMin: 1.0,
  },
  {
    //mts
    fullYearMax: 36.75,
    fullYearMin: 0.0,
    quarterMax: 50.67,
    quarterMin: 0.0,
  },
  {
    //med
    fullYearMax: 91.07,
    fullYearMin: 18.75,
    quarterMax: 100.0,
    quarterMin: 18.75,
  },
  {
    //twc
    fullYearMax: 69.3,
    fullYearMin: 5.0,
    quarterMax: 109.25,
    quarterMin: 0.75,
  },
];

export const quartersWithData: any = {
  '2024': true,
  Q1: false,
  Q2: false,
  Q3: false,
  Q4: true,
};

export const outComeDropdownValues = [
  {
    value: 'Quota Attainment',
    label: 'Quota Attainment %',
  },
  // {
  //   value: 'New Bookings',
  //   label: 'Land ACV (Amount)',
  // },
  // {
  //   value: 'Total NACV',
  //   label: 'Total NACV (Amount)',
  // },
  // {
  //   value: 'Renewals',
  //   label: 'Expand ACV (Amount)',
  // },
  // {
  //   value: 'Pipeline Generated',
  //   label: 'Pipeline Generated (Amount)',
  // },
  // {
  //   value: 'Deal Size',
  //   label: 'Deal Size (Amount)',
  // },
  // {
  //   value: 'Sales Cycle',
  //   label: 'Sales Cycle (Days)',
  // },
  {
    value: 'Win Rate',
    label: 'Win Rate %',
  },
];

export const roleName: { [key: string]: string } = {
  ADMIN: 'Admin',
  LEADER: 'Manager',
  AE: 'Rep',
  EXEC: 'Exec',
};

export const personaList = [
  {
    value: 'ADMIN',
    name: 'Admin',
  },
  {
    value: 'LEADER',
    name: 'Manager',
  },
  {
    value: 'AE',
    name: 'Rep',
  },
  {
    value: 'EXEC',
    name: 'Exec',
  },
  {
    value: 'SDR',
    name: 'SDR',
  },
];

export const fiveBubbleLabel: { [key: number]: string } = {
  '0':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">10%</span></div>',
  '1':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">Quartile</span></div>',
  '2':
    '<div><span style="display:flex;justify-content:center">Middle</span><span style="display:flex;justify-content:center;">Performer</span></div>',
  '3':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">Quartile</span></div>',
  '4':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">10%</span></div>',
};

export const threeBubbleLabel: { [key: number]: string } = {
  '0':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">10%</span></div>',
  '1':
    '<div><span style="display:flex;justify-content:center">Middle</span><span style="display:flex;justify-content:center;">Performer</span></div>',
  '2':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">10%</span></div>',
};

export const fourBubbleLabel: { [key: number]: string } = {
  '0':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">10%</span></div>',
  '1':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">Quartile</span></div>',
  '2':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">Quartile</span></div>',
  '3':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">10%</span></div>',
};

export const fiveBubbleHeaders: { [key: number]: string } = {
  '1': 'Low-Performers',
  '2': 'Below Average - Performers',
  '3': 'Mid-Performers',
  '4': 'High-Performers',
  '5': 'Out-Performers',
};

export const fourBubbleHeaders: { [key: number]: string } = {
  '1': 'Low-Performers',
  '2': 'Mid-Performers',
  '3': 'High-Performers',
  '4': 'Out-Performers',
};
export const threeBubbleHeaders: { [key: number]: string } = {
  '1': 'Low-Performers',
  '2': 'Mid-Performers',
  '3': 'High-Performers',
};

export const percentageDrivers = [
  'Total Connects / Attempts',
  'Future Interest / Connects',
  'Followups / Connects',
  'Meetings Rescheduled / Connects',
];

export const colorCode = [
  { primary: 'rgb(224, 69, 50)', secondary: 'rgb(224  69  50 / 20%)' },
  { primary: 'rgb(242, 113, 69)', secondary: 'rgb(242  113  69 / 20%)' },
  { primary: 'rgb(245, 126, 75)', secondary: 'rgb(245  126  75 / 20%)' },
  { primary: 'rgb(251, 162, 93)', secondary: 'rgb(251  162  93 / 20%)' },
  { primary: 'rgb(166, 217, 111)', secondary: 'rgb(166  217  111 / 20%)' },
  { primary: 'rgb(163, 216, 110)', secondary: 'rgb(163  216  110 / 20%)' },
  { primary: 'rgb(154, 212, 107)', secondary: 'rgb(154  212  107 / 20%)' },
  { primary: 'rgb(156, 213, 108)', secondary: 'rgb(156  213  108 / 20%)' },
  { primary: 'rgb(136, 204, 103)', secondary: 'rgb(136  204  103 / 20%)' },
  { primary: 'rgb(116, 195, 100)', secondary: 'rgb(116  195  100 / 20%)' },
  { primary: 'rgb(128, 200, 102)', secondary: 'rgb(128  200  102 / 20%)' },
  { primary: 'rgb(124, 199, 101)', secondary: 'rgb(124  199  101 / 20%)' },
  { primary: 'rgb(251, 160, 92)', secondary: 'rgb(251  160  92 / 20%)' },
  { primary: 'rgb(15, 130, 68)', secondary: 'rgb(15  130  68 / 20%)' },
  { primary: 'rgb(60, 167, 88)', secondary: 'rgb(60  167  88 / 20%)' },
  { primary: 'rgb(59, 167, 87)', secondary: 'rgb(59  167  87 / 20%)' },
  { primary: 'rgb(69, 173, 90)', secondary: 'rgb(69  173  90 / 20%)' },
  { primary: 'rgb(88, 182, 95)', secondary: 'rgb(88  182  95 / 20%)' },
  {
    primary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(241, 111, 68)"
          ],
          [
              1,
              "rgb(191, 228, 123)"
          ]
      ]
  }`,
    secondary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(241  111  68 / 20%)"
          ],
          [
              1,
              "rgb(191  228  123 / 20%)"
          ]
      ]
  }`,
  },
  {
    primary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(250, 158, 91)"
          ],
          [
              1,
              "rgb(191, 228, 123)"
          ]
      ]
  }`,
    secondary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(250  158  91 / 20%)"
          ],
          [
              1,
              "rgb(191  228  123 / 20%)"
          ]
      ]
  }`,
  },
  {
    primary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(125, 199, 101)"
          ],
          [
              1,
              "rgb(191, 228, 123)"
          ]
      ]
  }`,
    secondary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(125  199  101 / 20%)"
          ],
          [
              1,
              "rgb(191  228  123 / 20%)"
          ]
      ]
  }`,
  },
  { primary: 'rgb(0, 104, 55)', secondary: 'rgb(0  104  55 / 20%)' },
  { primary: 'rgb(229, 80, 54)', secondary: 'rgb(229  80  54 / 20%)' },
];

export const activeNudges = [
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    action: 'Technical Skills - Advanced',
    primary_driver: 'Technical Skills',
    actionCompleteDate: '2024-05-11T23:16:03.024Z',
    createdDate: '2024-02-11T18:30:00.000Z',
    doneDate: null,
    managerName: 'Leyla',
  },
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    action: 'Meet with Product Teams',
    primary_driver: 'Time with Product team',
    actionCompleteDate: '2024-04-30T05:09:24.294Z',
    createdDate: '2024-01-30T18:30:00.000Z',
    doneDate: null,
    managerName: 'Leyla',
  },
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    action: 'Practice Discovery skills',
    primary_driver: 'Discovery skills',
    actionCompleteDate: '2024-04-13T17:13:11.098Z',
    createdDate: '2024-01-13T18:30:00.000Z',
    doneDate: null,
    managerName: 'Leyla',
  },
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    action: 'Focus on rigor with MEDPICC execution',
    primary_driver: 'MEDPICC score',
    actionCompleteDate: '2024-04-02T23:16:03.024Z',
    createdDate: '2024-01-02T18:30:00.000Z',
    doneDate: null,
    managerName: 'Leyla',
  },
  // {
  //   userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
  //   action: 'Follow up ratio with customer',
  //   primary_driver: 'Follow-up',
  //   actionCompleteDate: '2023-03-27T17:13:11.098Z',
  //   createdDate: '2022-12-27T18:30:00.000Z',
  //   doneDate: null,
  //   managerName: 'Leyla',
  // },
  // {
  //   userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
  //   action: 'Focus on cadence with their Pipeline',
  //   primary_driver: 'Pipeline discipline',
  //   actionCompleteDate: '2023-03-14T23:16:03.024Z',
  //   createdDate: '2022-12-14T18:30:00.000Z',
  //   doneDate: null,
  //   managerName: 'Leyla',
  // },
];

export const json = [
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    activity: 'Practice Consultative skills',
    primary_driver: 'Consultative Skills',
    due_date: '2023-05-26T15:27:26.281Z',
    nudgeDate: '2023-04-04',
    doneDate: '2023-05-04',
    impact: 'Score Increase: 2 >> 4',
    outcome: 'Quota Attainment',
    outcomeTrackerChartData: [
      {
        xAxis: '2022 Q1',
        value: 50,
        nudge: '',
      },
      {
        xAxis: '2022 Q2',
        value: 55,
        nudge: 'DONE DATE',
      },
      {
        xAxis: '2022 Q3',
        value: 65,
        nudge: '',
      },
      {
        xAxis: '2022 Q4',
        value: 65,
        nudge: '',
      },
      {
        xAxis: '2023 Q1',
        value: 72,
        nudge: '',
      },
      {
        xAxis: '2023 Q2',
        value: 78,
        nudge: '',
      },
    ],
  },
  // {
  //   userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
  //   activity: 'Multi-thread deals',
  //   primary_driver: 'Time with Customers',
  //   due_date: '2023-05-26T15:27:26.281Z',
  //   nudgeDate: '2022-04-27',
  //   doneDate: '2022-07-27',
  //   impact: 'Time with customers up by 20%',
  //   outcome: 'Deal Size',
  //   outcomeTrackerChartData: [
  //     {
  //       xAxis: '2022 Q1',
  //       value: 55, // $115K
  //       value1: 115,
  //       nudge: '',
  //     },
  //     {
  //       xAxis: '2022 Q2',
  //       value: 55, // $115K
  //       value1: 115,
  //       nudge: '',
  //     },
  //     {
  //       xAxis: '2022 Q3',
  //       value: 60, // $125K
  //       value1: 125,
  //       nudge: 'DONE DATE',
  //     },
  //     {
  //       xAxis: '2022 Q4',
  //       value: 75, // $125K
  //       value1: 150,
  //       nudge: '',
  //     },
  //     {
  //       xAxis: '2023 Q1', // $150K
  //       value: 75,
  //       value1: 150,
  //       nudge: '',
  //     },
  //     {
  //       xAxis: '2023 Q2', // $150K
  //       value: 80,
  //       value1: 165,
  //       nudge: '',
  //     },
  //   ],
  // },
];

export const chris_alicia = {
  battleCard: [
    {
      name: 'Chris Egel',
      userId: '10f99e38-a1b5-4149-b1c6-44134c7dc975',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Discovery Framework Score',
          value: 3,
          valueType: 'continuous',
          original_top_driver: 'Activity Score',
          predicted_outcome: '27.12',
          org_driver_mean_value: 36.8,
          X_poor_org_driver_value: 16,
          X_good_org_driver_value: 26,
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 10.5,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Time Allocation',
          name: 'With Product Team',
          value: 4.77,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge team to engage with experienced sellers',
          actionName:
            'Support <b style="font-weight:500">Chris Egel</b> and identify an experienced buddy seller they can partner with',
          course: 'Discovery Framework Score',
          driverDefinition: '',
        },
      ],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 10,
      driver2_max_value: 20.97,
      driver3_max_value: 30.75,
      driver1_min_value: 0,
      driver2_min_value: 5.23,
      driver3_min_value: 3.36,
      driver1_mean_value: 5,
      driver2_mean_value: 12.72,
      driver3_mean_value: 13.21,
      org_driver_max_value: 107,
      org_driver_min_value: 0,
    },
    {
      name: 'Alicia Brashaw',
      userId: 'Alicia Brashaw',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Discovery Framework Score',
          value: 7.5,
          valueType: 'continuous',
          original_top_driver: 'Activity Score',
          predicted_outcome: '27.12',
          org_driver_mean_value: 36.8,
          X_poor_org_driver_value: 6,
          X_good_org_driver_value: 26,
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 17.2,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Time Allocation',
          name: 'With Product Team',
          value: 22.79,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 10,
      driver2_max_value: 20.97,
      driver3_max_value: 30.75,
      driver1_min_value: 0,
      driver2_min_value: 5.23,
      driver3_min_value: 3.36,
      driver1_mean_value: 5,
      driver2_mean_value: 12.72,
      driver3_mean_value: 13.21,
      org_driver_max_value: 107,
      org_driver_min_value: 0,
    },
  ],
};

export const devin_Tildi = {
  battleCard: [
    {
      name: 'Irwinn Torres',
      userId: '2f823637-c41c-4958-b1fc-a8221364414d',
      battleCardData: [
        {
          title: 'Time Allocation',
          name: 'Time w/ Partner',
          value: 11.4,
          valueType: 'continuous',
          original_top_driver: 'MEDPICC Score',
          predicted_outcome: '40.72',
          org_driver_mean_value: 60.41,
          X_poor_org_driver_value: 30,
          X_good_org_driver_value: 86,
        },
        {
          title: 'Activity',
          name: 'Activity Score',
          value: 13.2,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Competency',
          name: 'Technical Skills',
          value: 2.0,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge your team to monitor deal stage',
          actionName:
            'Coach <b style="font-weight:500">Irwinn Torres</b> to deepen partner engagement, increasing time allocation from 11.4 hrs/quarter to 21.8 hrs/quarter.',
          actionName1:
            'Reps with Partner - Time Allocation of 21.8+ have a win rate of 10% higher than average.',
          course: 'Partner - Time Allocation',
          driverDefinition: '',
        },
      ],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 32.3,
      driver2_max_value: 24.5,
      driver3_max_value: 5,
      driver1_min_value: 0,
      driver2_min_value: 1.1,
      driver3_min_value: 0,
      driver1_mean_value: 21.8,
      driver2_mean_value: 16.07,
      driver3_mean_value: 3.5,
      org_driver_max_value: 107,
      org_driver_min_value: 0,
    },
    {
      name: 'Tildi Baines',
      userId: 'Tildi Baines',
      battleCardData: [
        {
          title: 'Time Allocation',
          name: 'Time w/ Partner',
          value: 26.8,
          valueType: 'continuous',
          original_top_driver: 'Months in role',
          predicted_outcome: '17.83',
          org_driver_mean_value: 36.8,
          X_poor_org_driver_value: 44,
          X_good_org_driver_value: 10,
          driver_corr: 'positive',
        },
        {
          title: 'Activity',
          name: 'Activity Score',
          value: 21.4,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Competency',
          name: 'Technical Skills',
          value: 4.0,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 32.3,
      driver2_max_value: 24.5,
      driver3_max_value: 5,
      driver1_min_value: 0,
      driver2_min_value: 1.1,
      driver3_min_value: 0,
      driver1_mean_value: 21.8,
      driver2_mean_value: 16.07,
      driver3_mean_value: 3.5,
      org_driver_max_value: 107,
      org_driver_min_value: 0,
    },
  ],
};

export const benito_miller = {
  battleCard: [
    {
      name: 'Benito Sketch',
      userId: '43d5b506-19c3-4d51-9108-6eefcbecc87a',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Power Map Score',
          value: 2,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '34.37',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 14,
          X_good_org_driver_value: 18,
          driver_corr: 'positive',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 29.33,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Total Activity',
          value: 50.92715232,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge your team to keep deals updated',
          actionName:
            'Encourage <b style="font-weight:500">Blake Philippe</b> to update key deal fields weekly',
          course: 'Power Map Score',
          driverDefinition:
            'Completion of relevant fields by rep in every opportunity. Weighted score of # of fields completed AND the frequency of updation.',
        },
      ],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 10,
      driver2_max_value: 49.68,
      driver3_max_value: 84.35,
      driver1_min_value: 0,
      driver2_min_value: 11.45,
      driver3_min_value: 57.33,
      driver1_mean_value: 5,
      driver2_mean_value: 33.78,
      driver3_mean_value: 62.22,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
    {
      name: 'Miller Baumford',
      userId: 'Miller Baumford',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Power Map Score',
          value: 8,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '34.37',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 14,
          X_good_org_driver_value: 18,
          driver_corr: 'positive',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 37.99,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Total Activity',
          value: 63.4444,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
      ],
      battleCardActions: [],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 10,
      driver2_max_value: 49.68,
      driver3_max_value: 84.35,
      driver1_min_value: 0,
      driver2_min_value: 11.45,
      driver3_min_value: 57.33,
      driver1_mean_value: 5,
      driver2_mean_value: 33.78,
      driver3_mean_value: 62.22,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
  ],
};

export const rubetta_corey = {
  battleCard: [
    {
      name: 'Rubetta Flippini',
      userId: '0e401502-d8dd-4b62-aed6-f73960a5498d',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Command of the Message Score',
          value: 2.5,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '23.64',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 48,
          X_good_org_driver_value: 18,
          driver_corr: 'positive',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 14.44,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 11.9047619,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge team to engage with experienced sellers',
          actionName:
            'Support <b style="font-weight:500">Rubetta Flippini</b> and identify an experienced buddy seller they can partner with',
          course: 'Command of the Message Score',
          driverDefinition: '',
        },
      ],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 10,
      driver2_max_value: 49.68,
      driver3_max_value: 20.97,
      driver1_min_value: 0,
      driver2_min_value: 11.45,
      driver3_min_value: 5.23,
      driver1_mean_value: 5,
      driver2_mean_value: 33.78,
      driver3_mean_value: 12.72,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
    {
      name: 'Corey Larenson',
      userId: 'Corey Larenson',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Command of the Message Score',
          value: 7,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '23.64',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 48,
          X_good_org_driver_value: 18,
          driver_corr: 'positive',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 36.79,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 15.5,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 10,
      driver2_max_value: 49.68,
      driver3_max_value: 20.97,
      driver1_min_value: 0,
      driver2_min_value: 11.45,
      driver3_min_value: 5.23,
      driver1_mean_value: 5,
      driver2_mean_value: 33.78,
      driver3_mean_value: 12.72,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
  ],
};

export const rubetta_bic = {
  battleCard: [
    {
      name: 'Rubetta Flippini',
      userId: '0e401502-d8dd-4b62-aed6-f73960a5498d',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Command of the Message Score',
          value: 2.5,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '23.64',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 48,
          X_good_org_driver_value: 18,
          driver_corr: 'positive',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 14.44,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 11.9047619,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge team to engage with experienced sellers',
          actionName:
            'Support <b style="font-weight:500">Rubetta Flippini</b> and identify an experienced buddy seller they can partner with',
          course: 'Command of the Message Score',
          driverDefinition: '',
        },
      ],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 10,
      driver2_max_value: 49.68,
      driver3_max_value: 20.97,
      driver1_min_value: 0,
      driver2_min_value: 11.45,
      driver3_min_value: 5.23,
      driver1_mean_value: 5,
      driver2_mean_value: 33.78,
      driver3_mean_value: 12.72,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
    {
      name: 'Best In Class',
      userId: 'bic_user_id',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Command of the Message Score',
          value: 8.5,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '23.64',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 48,
          X_good_org_driver_value: 18,
          driver_corr: 'positive',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 38.25,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 17.4,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 10,
      driver2_max_value: 49.68,
      driver3_max_value: 20.97,
      driver1_min_value: 0,
      driver2_min_value: 11.45,
      driver3_min_value: 5.23,
      driver1_mean_value: 5,
      driver2_mean_value: 33.78,
      driver3_mean_value: 12.72,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
  ],
};

export const evelyn_silvia = {
  battleCard: [
    {
      name: 'Evelyn Strickland',
      userId: '7fe0bdeb-cccc-43df-8db1-ace41be8b10b',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Value Map Score',
          value: 2,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '33.51',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 33,
          X_good_org_driver_value: 31,
          driver_corr: 'positive',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 28.1,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 12.19512195,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge your team to focus on deal execution',
          actionName:
            'Encourage <b style="font-weight:500">Evelyn Strickland</b> to identify the customer Objectives (O) clearly in the value selling  process, going from score of 2 to 5.',
          actionName1:
            'Reps where the Objectives are identified and quantified, close at 15% higher rate.',
          actionName2:
            'This will enable <b style="font-weight:500">Evelyn Strickland</b> to lift Quota Attainment from <b style="font-weight:500">33% ($200.6K)</b> to an estimated <b style="font-weight:500">38% ($232.6K)</b> over 3 months, accelerating estimated bookings by $32.0K next quarter.',
          course: 'Value Map Score (Objectives)',
        },
      ],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 10,
      driver2_max_value: 49.68,
      driver3_max_value: 20.97,
      driver1_min_value: 0,
      driver2_min_value: 11.45,
      driver3_min_value: 5.23,
      driver1_mean_value: 5,
      driver2_mean_value: 33.78,
      driver3_mean_value: 12.72,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
    {
      name: 'Silvia Sadler',
      userId: 'Silvia Sadler',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Value Map Score',
          value: 7,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '33.51',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 33,
          X_good_org_driver_value: 31,
          driver_corr: 'positive',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 36.17,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 14.28571429,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 10,
      driver2_max_value: 49.68,
      driver3_max_value: 20.97,
      driver1_min_value: 0,
      driver2_min_value: 11.45,
      driver3_min_value: 5.23,
      driver1_mean_value: 5,
      driver2_mean_value: 33.78,
      driver3_mean_value: 12.72,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
  ],
};

export const evelyn_bic = {
  battleCard: [
    {
      name: 'Evelyn Strickland',
      userId: '7fe0bdeb-cccc-43df-8db1-ace41be8b10b',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Value Map Score',
          value: 2,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '33.51',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 33,
          X_good_org_driver_value: 31,
          driver_corr: 'positive',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 28.1,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 12.19512195,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge your team to focus on deal execution',
          actionName:
            'Encourage <b style="font-weight:500">Evelyn Strickland</b> to identify the customer Objectives (O) clearly in the value selling  process, going from score of 2 to 5.',
          actionName1:
            'Reps where the Objectives are identified and quantified, close at 15% higher rate.',
          actionName2:
            'This will enable <b style="font-weight:500">Evelyn Strickland</b> to lift Quota Attainment from <b style="font-weight:500">33% ($200.6K)</b> to an estimated <b style="font-weight:500">38% ($232.6K)</b> over 3 months, accelerating estimated bookings by $32.0K next quarter.',
          course: 'Value Map Score (Objectives)',
        },
      ],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 10,
      driver2_max_value: 49.68,
      driver3_max_value: 20.97,
      driver1_min_value: 0,
      driver2_min_value: 11.45,
      driver3_min_value: 5.23,
      driver1_mean_value: 5,
      driver2_mean_value: 33.78,
      driver3_mean_value: 12.72,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
    {
      name: 'Best In Class',
      userId: 'bic_user_id',
      battleCardData: [
        {
          title: 'Activity',
          name: 'Value Map Score',
          value: 8,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '33.51',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 33,
          X_good_org_driver_value: 31,
          driver_corr: 'positive',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 44,
          valueType: 'continuous',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 20,
          valueType: 'continuous',
        },
      ],
      battleCardActions: [],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 10,
      driver2_max_value: 49.68,
      driver3_max_value: 20.97,
      driver1_min_value: 0,
      driver2_min_value: 11.45,
      driver3_min_value: 5.23,
      driver1_mean_value: 5,
      driver2_mean_value: 33.78,
      driver3_mean_value: 12.72,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
  ],
};

export const whiney_bic = {
  battleCard: [
    {
      name: 'Whitney Duggen',
      userId: '7e277063-744d-4303-b49e-5a7e0d67bd95',
      battleCardData: [
        {
          title: 'Activity',
          name: 'MEDPICC Score (%)',
          value: 30,
          valueType: 'continuous',
          original_top_driver: 'MEDPICC Score',
          predicted_outcome: '41.92',
          org_driver_mean_value: 60.41,
          X_poor_org_driver_value: 30,
          X_good_org_driver_value: 86,
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 19,
          valueType: 'continuous',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 11.33333333,
          valueType: 'continuous',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge your team to focus on deal execution',
          actionName:
            'Encourage <b style="font-weight:500">Whitney Duggen</b> to identify the Economic buyer (E) earlier in the sales process, going from 12 days post initial call to 5 days.',
          actionName1:
            'Deals where an economic buyer is identified within the 5 days post initial call, close at 15% higher rate.',
          actionName2:
            'This will enable <b style="font-weight:500">Whitney Duggen</b> to lift Quota Attainment from <b style="font-weight:500">27% ($545.7K)</b> to an estimated <b style="font-weight:500">33% ($660.0K)</b> over 3 months, accelerating estimated bookings by $114.3K next quarter.',
          course: 'MEDPICC Score  (Economic Buyer)',
        },
      ],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 99,
      driver2_max_value: 49.68,
      driver3_max_value: 20.97,
      driver1_mean_value: 60.41,
      driver2_mean_value: 33.67,
      driver3_mean_value: 12.71,
      org_driver_max_value: 99,
      org_driver_min_value: 1,
    },
    {
      name: 'Best In Class',
      userId: 'bic_user_id',
      battleCardData: [
        {
          title: 'Activity',
          name: 'MEDPICC Score (%)',
          value: 90,
          valueType: 'continuous',
          original_top_driver: 'MEDPICC Score',
          predicted_outcome: '41.92',
          org_driver_mean_value: 60.41,
          X_poor_org_driver_value: 30,
          X_good_org_driver_value: 86,
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 44,
          valueType: 'continuous',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 20,
          valueType: 'continuous',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 99,
      driver2_max_value: 49.68,
      driver3_max_value: 20.97,
      driver1_mean_value: 60.41,
      driver2_mean_value: 33.67,
      driver3_mean_value: 12.71,
      org_driver_max_value: 99,
      org_driver_min_value: 1,
    },
  ],
};

export const marco_wolf = {
  battleCard: [
    {
      name: 'Marco Gallo',
      userId: '282bca25-fcca-4ab1-b0e5-315e4da540ae',
      battleCardData: [
        {
          title: 'Competency',
          name: 'Acq. Framework (Align Solutions to Needs)',
          value: 1.5,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '25.74',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 9,
          X_good_org_driver_value: 24,
          driver_corr: 'positive',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 10.3,
          valueType: 'continuous',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 27.29,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge your team to keep deals updated',
          actionName:
            'Encourage <b style="font-weight:500">Marco Gallo</b> to update key deal fields weekly',
          course: 'Align Solutions to Needs',
          driverDefinition:
            'Completion of relevant fields by rep in every opportunity. Weighted score of # of fields completed AND the frequency of updation.',
        },
      ],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 5,
      driver2_max_value: 20.97,
      driver3_max_value: 49.68,
      driver1_min_value: 0,
      driver2_min_value: 0,
      driver3_min_value: 11.45,
      driver1_mean_value: 3.5,
      driver2_mean_value: 12.71,
      driver3_mean_value: 33.78,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
    {
      name: 'Wolf Peatman',
      userId: 'Wolf Peatman',
      battleCardData: [
        {
          title: 'Competency',
          name: 'Acq. Framework (Align Solutions to Needs)',
          value: 4,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '25.74',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 9,
          X_good_org_driver_value: 24,
          driver_corr: 'positive',
        },
        {
          title: 'Activity',
          name: 'Follow-Up with Customers',
          value: 20,
          valueType: 'continuous',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 38.79,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
      ],
      battleCardActions: [],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 5,
      driver2_max_value: 20.97,
      driver3_max_value: 49.68,
      driver1_min_value: 0,
      driver2_min_value: 0,
      driver3_min_value: 11.45,
      driver1_mean_value: 3.5,
      driver2_mean_value: 12.71,
      driver3_mean_value: 33.78,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
  ],
};

export const collen_maxi = {
  battleCard: [
    {
      name: 'Collen Siaspinski',
      userId: 'f11e82e1-79f5-4d5c-811b-32d71c46ae2d',
      battleCardData: [
        {
          title: 'Competency',
          name: 'Acq. Framework (Articulate Meaningful Value)',
          value: 2,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '23.34',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 45,
          X_good_org_driver_value: 33,
          driver_corr: 'positive',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 21.29,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Email - Time to respond',
          value: 5.4,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [
        {
          header: 'Nudge team to engage with experienced sellers',
          actionName:
            'Support <b style="font-weight:500">Collen Siaspinski</b> and identify an experienced buddy seller they can partner with',
          course: 'Articulate Meaningful Value',
          driverDefinition: '',
        },
      ],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 5,
      driver2_max_value: 49.68,
      driver3_max_value: 16,
      driver1_min_value: 0,
      driver2_min_value: 11.45,
      driver3_min_value: 1,
      driver1_mean_value: 3.5,
      driver2_mean_value: 33.78,
      driver3_mean_value: 7.86,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
    {
      name: 'Maxi Brim',
      userId: 'Maxi Brim',
      battleCardData: [
        {
          title: 'Competency',
          name: 'Acq. Framework (Articulate Meaningful Value)',
          value: 4.5,
          valueType: 'continuous',
          original_top_driver: 'App Hygiene (CRM completeness)',
          predicted_outcome: '23.34',
          org_driver_mean_value: 35.41,
          X_poor_org_driver_value: 45,
          X_good_org_driver_value: 33,
          driver_corr: 'positive',
        },
        {
          title: 'Time Allocation',
          name: 'With Customers',
          value: 38.79,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Activity',
          name: 'Email - Time to respond',
          value: 12,
          valueType: 'continuous',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Attributes',
      battleCardType: 'Battlecards',
      driver1_max_value: 5,
      driver2_max_value: 49.68,
      driver3_max_value: 16,
      driver1_min_value: 0,
      driver2_min_value: 11.45,
      driver3_min_value: 1,
      driver1_mean_value: 3.5,
      driver2_mean_value: 33.78,
      driver3_mean_value: 7.86,
      org_driver_max_value: 88,
      org_driver_min_value: 1,
    },
  ],
};
